import {
  getProfile,
  updateProfile,
  saveApproval,
  deletePicture,
  updatePicture,
} from '../../services/api/profile.service';
import { openAlert } from './alert';
import i18n from '../../i18n';

export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_USER_APPROVAL = 'SET_USER_APPROVAL';
export const USER_IMAGE_UPDATE = 'USER_IMAGE_UPDATE';
export const SET_USER_PICTURE = 'SET_USER_PICTURE';

// FIXME: It should be in actions/auth.js, but this was changed to avoid undefined calls
export const userImageUpdation = (imageUrl) => {
  return (dispatch) => {
    dispatch({ type: USER_IMAGE_UPDATE, imageUrl });
  };
};

export const getProfileData = () => {
  return async (dispatch) => {
    const userProfile = await getProfile();
    dispatch({ type: SET_USER_PROFILE, userProfile });
  };
};

export const saveUserPicture = (data) => {
  return async (dispatch) => {
    const response = await updatePicture(data);
    dispatch({
      type: SET_USER_PICTURE,
      ImageBytes: response.ImageUrl,
    });
    dispatch(userImageUpdation(response.ImageUrl));
    dispatch(openAlert({ title: response.ResponseMsg }));
  };
};

export const deleteUserPicture = (data) => {
  return async (dispatch) => {
    const response = await deletePicture(data);
    dispatch({ type: SET_USER_PICTURE, ImageBytes: null });
    dispatch(userImageUpdation(response.ImageUrl));
    dispatch(openAlert({ title: response.ResponseMsg }));
  };
};

export const updateProfileData = (data) => {
  return async (dispatch) => {
    const response = await updateProfile(data);
    dispatch(getProfileData());
    dispatch(userImageUpdation(response.ImageUrl));
    dispatch(openAlert({ title: i18n.t('me:ProfileForm.' + response.ResponseMsg) }));
  };
};

export const saveApprover = (data) => {
  return async (dispatch) => {
    const resp = await saveApproval(data);
    dispatch({ type: SET_USER_APPROVAL, resp });
    dispatch(openAlert({ title: resp.ResponseMsg }));
  };
};
